import React, { useState, useEffect, useRef } from 'react';
import Axios from 'axios';
import Print from '../../../Common_Files/Print';
import { Host } from '../../../App';
import './Temporary_Inventory.css'

function Flex_Inventory({ partDataset, onhandparts, AllColumns, Area }) {
  const token = window.localStorage.getItem("acessToken");
  const userName = (window.localStorage.getItem("Name") || '').replace(/[{""}]/g, "");
  const currentDate = new Date();
  const [Inventory_Date, setInventory_Date] = useState(currentDate.toISOString().slice(0, 10));

  const [filterText, setFilterText] = useState({ customer: '', desc: '' });
  const [allParts, setAllParts] = useState([]);
  const [filteredParts, setfilteredParts] = useState([]);

  const [printTrigger, setPrintTrigger] = useState(false);
  const [Qtyvalue, setQtyvalue] = useState(false); // acts as "editable" toggle

  // FIX 3: QTY Value button now copies on-hand to QTY instead of just toggling edit
  const Qty_Value = () => {
    if (!Qtyvalue) {
      // Turning ON edit mode — copy on-hand values into QTY fields
      setAllParts(prev =>
        prev.map(p => {
          const onH = getOnHandF(p.Part_internalNo);
          return { ...p, QTY: onH !== '' ? String(onH) : (p.QTY ?? '') };
        })
      );
    }
    setQtyvalue(s => !s);
  };

  const tableRef = useRef(null);

  // FIX 4: Build a clean compact print HTML — no Bootstrap, no inputs, tight rows, landscape
  const handlePrint = () => {
    const colHeaders = [
      'PART NO',
      'INTERNAL PART NUMBER',
      ...(AllColumns ? ['PART DESCRIPTION'] : []),
      'CUSTOMER',
      ...(AllColumns ? ['CATEGORY', 'TYPE'] : []),
      'QTY',
      'ON HAND',
    ];

    const rows = filteredParts.map(val => {
      const onH = getOnHandF(val.Part_internalNo);
      const cells = [
        val.Part_No || val.PartNo || '',
        val.Part_internalNo || '',
        ...(AllColumns ? [val.Part_Description || val.Part_description || ''] : []),
        val.Customer || '',
        ...(AllColumns ? [val.CATEGORY || '', val.Type || ''] : []),
        '', // QTY — always blank for manual writing
        onH !== '' ? String(onH) : '',
      ];
      return `<tr>${cells.map((c, i) => {
        // QTY column: blank cell with a bottom border line to write on
        const isQty = i === cells.length - 2;
        return `<td style="${isQty
          ? 'border-bottom:1.5px solid #333;min-width:60px;'
          : ''}">${c}</td>`;
      }).join('')}</tr>`;
    }).join('');

    const printHTML = `
      <style>
        @page { size: A4 landscape; margin: 10mm 8mm; }
        body { font-family: Arial, sans-serif; font-size: 8px; margin: 0; }
        h3 { font-size: 11px; margin: 0 0 4px 0; text-align: center; }
        p.meta { font-size: 7.5px; margin: 0 0 6px 0; text-align: center; color:#555; }
        table { width: 100%; border-collapse: collapse; table-layout: auto; }
        th {
          background: #2c3e50; color: #fff;
          font-size: 7.5px; font-weight: bold;
          padding: 3px 4px; text-align: left;
          border: 1px solid #aaa;
        }
        td {
          font-size: 7.5px; padding: 2px 4px;
          border: 1px solid #ddd; white-space: nowrap;
        }
        tr:nth-child(even) td { background: #f5f5f5; }
      </style>
      <h3>${Area || 'Flex Inventory'}</h3>
      <p class="meta">Date: ${Inventory_Date} &nbsp;|&nbsp; Printed by: Vikas</p>
      <table>
        <thead>
          <tr>${colHeaders.map(h => `<th>${h}</th>`).join('')}</tr>
        </thead>
        <tbody>${rows}</tbody>
      </table>
    `;

    setPrintTrigger({ html: printHTML });
  };

  const [del, setdel] = useState(0);

  // ---------- Helpers ----------
  const norm = (txt) =>
    String(txt || '')
      .replace(/[–—]/g, '-')
      .replace(/^\s*(Main\s*Part\s*-\s*|Sub\s*Part\s*-\s*)/i, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();

  // ---------- Build On Hand Map ----------
  const [onHandMap, setOnHandMap] = useState({});

  useEffect(() => {
    const map = {};
    (onhandparts || []).forEach(row => {
      const s = String(row?.Pending_Parts_List || '');
      if (!s) return;

      s.split(',').forEach(chunk => {
        const c = chunk.trim();
        const m = c.match(/(?:Main\s*Part\s*-\s*|Sub\s*Part\s*-\s*)?(.*?-F)\s*\((\-?\d+)\)/i);
        if (m) {
          const internal = norm(m[1]);
          const qty = Number(m[2]) || 0;
          map[internal] = qty;
        }
      });
    });
    setOnHandMap(map);
  }, [onhandparts]);

  // Use ref so getOnHandF always has latest map (avoids stale closure issues)
  const onHandMapRef = useRef(onHandMap);
  useEffect(() => { onHandMapRef.current = onHandMap; }, [onHandMap]);

  const getOnHandF = (internalNo) => onHandMapRef.current[norm(internalNo)] ?? '';

  // ---------- FIX 1: Seed page rows — QTY starts EMPTY, never prefilled from on-hand here ----------
  useEffect(() => {
    const initializeParts = () => {
      const savedData = localStorage.getItem('FlexunsavedPartsData');
      let parts = [];

      const base = (partDataset || [])
        .filter(part =>
          String(part.Part_internalNo || '').trim().toUpperCase().endsWith('-F')
        )
        .map(part => ({ ...part }));

      if (savedData) {
        try {
          const parsed = JSON.parse(savedData);
          parts = base.map(part => {
            const savedMatch = parsed.find(p => p.Part_internalNo === part.Part_internalNo);
            // Only restore manually saved QTY (from a previous Update), not auto-prefilled values
            return savedMatch
              ? { ...part, ...savedMatch }
              : { ...part, QTY: '', User: userName }; // start blank
          });
        } catch (err) {
          console.error("Error parsing saved data", err);
          localStorage.removeItem('FlexunsavedPartsData');
          parts = base.map(part => ({ ...part, QTY: '', User: userName }));
        }
      } else {
        // FIX 1: Always start with empty QTY — do NOT read on-hand here
        parts = base.map(part => ({ ...part, QTY: '', User: userName }));
      }

      parts.sort((a, b) =>
        String(a.Customer || '').localeCompare(String(b.Customer || ''))
      );
      setAllParts(parts);
      setfilteredParts(parts);
    };

    if (Array.isArray(partDataset) && partDataset.length > 0) initializeParts();
  }, [partDataset, userName]);

  // FIX 1: Removed the useEffect that auto-prefilled QTY from onHandMap.
  // On-hand values are now only copied when the user explicitly clicks "QTY Value".

  // ---------- Filtering ----------
  useEffect(() => {
    const filtered = allParts.filter(part =>
      (filterText.customer === '' ||
        String(part.Customer || '').toLowerCase().includes(filterText.customer.toLowerCase())) &&
      (filterText.desc === '' ||
        String(part.Part_internalNo || '').toLowerCase().includes(filterText.desc.toLowerCase()))
    );
    setfilteredParts(filtered);
  }, [filterText, allParts]);

  // Persist edits locally
  useEffect(() => {
    localStorage.setItem('FlexunsavedPartsData', JSON.stringify(allParts));
  }, [allParts]);

  const handleInputChange = (e, index, key) => {
    const { value } = e.target;
    updateDatas(allParts[index], key, value);
  };

  const updateDatas = (partObj, key, value) => {
    setAllParts(prev =>
      prev.map(row =>
        row.Part_internalNo === partObj.Part_internalNo ? { ...row, [key]: value } : row
      )
    );
  };

  // ---------- UPDATE ----------
  const Update = () => {
    const changedData_ = allParts
      .map(part => ({ part, qtyNum: Number(part.QTY) }))
      .filter(({ qtyNum }) => qtyNum > 0)
      .map(({ part, qtyNum }) => ({
        ...part,
        QTY: qtyNum,
        Date: Inventory_Date,
        Area: "Flex",
        User: userName
      }));

    if (!changedData_.length) {
      alert("No rows with QTY > 0 to send.");
      return;
    }

    Axios.post(`https://${Host}/Part_Inventory/Flex/Add`, {
      changedData: JSON.stringify(changedData_),
      token
    })
      .then(res => {
        if (res.status === 200) {
          alert(res.data.message || "Inventory updated.");
          localStorage.removeItem('FlexunsavedPartsData');
          window.location.reload();
          setdel(prev => prev + 1);
        }
      })
      .catch(err => {
        console.error("Error from backend:", err);
        alert("Error while saving. Check console for details.");
      });
  };

  // FIX 2: Clear All — clears QTY in state without reloading the page
  const ClearAll = () => {
    localStorage.removeItem('FlexunsavedPartsData');
    setAllParts(prev => prev.map(p => ({ ...p, QTY: '' })));
    setQtyvalue(false); // also lock the QTY inputs
    window.alert("Cleared!");
  };

  return (
    <div>
      <div className="row">
        <div className="col">
          <input
            type="text"
            className="form-control"
            placeholder="Filter by Customer"
            onChange={(e) => setFilterText({ ...filterText, customer: e.target.value })}
            list='Customer'
          />
          <datalist id="Customer">
            {[...new Set(allParts.map(x => x.Customer).filter(Boolean))].map((Customer, index) => (
              <option key={index} value={Customer} />
            ))}
          </datalist>
        </div>

        <div className="col">
          <input
            type="text"
            className="form-control"
            placeholder="Filter by Internal Part"
            list="PartDescription"
            onChange={(e) => setFilterText({ ...filterText, desc: e.target.value })}
          />
          <datalist id="PartDescription">
            <option></option>
            {allParts.map(x => <option key={x.Part_internalNo}>{x.Part_internalNo}</option>)}
          </datalist>
        </div>

        <div className="col">
          <button className="btn btn-success" onClick={Qty_Value}>
            {Qtyvalue ? "Lock QTY" : "QTY Value"}
          </button>
          <button className='btn btn-info ms-2' onClick={handlePrint}>Print</button>
        </div>

        <div className="col d-flex gap-2">
          <button className='btn btn-primary' onClick={Update}>Update</button>
          <button className='btn btn-secondary' onClick={ClearAll}>Clear All</button>
        </div>
      </div>

      <div className="inventory_table">
        <table className="table table-sm table-striped" id="alldata_openorder" ref={tableRef}>
          <thead>
            <tr>
              <th colSpan={8}>
                <input
                  type="date"
                  className="form-control form-rounded"
                  value={Inventory_Date}
                  onChange={(e) => setInventory_Date(e.target.value)}
                  style={{ maxWidth: 180 }}
                />
              </th>
            </tr>
            <tr>
              <th>PART NO</th>
              <th>INTERNAL PART NUMBER</th>
              {AllColumns ? <th>PART DESCRIPTION</th> : null}
              <th>CUSTOMER</th>
              {AllColumns ? <th>CATEGORY</th> : null}
              {AllColumns ? <th>TYPE</th> : null}
              <th>QTY</th>
              <th>On hand parts</th>
            </tr>
          </thead>

          <tbody>
            {filteredParts.map((val) => {
              const realIndex = allParts.findIndex(p => p.Part_internalNo === val.Part_internalNo);
              const onHandDisplay = getOnHandF(val.Part_internalNo);

              return (
                <tr key={val.Part_internalNo}>
                  <td>{val.Part_No || val.PartNo}</td>
                  <td>{val.Part_internalNo}</td>
                  {AllColumns ? <td>{val.Part_Description || val.Part_description}</td> : null}
                  <td>{val.Customer}</td>
                  {AllColumns ? <td>{val.CATEGORY}</td> : null}
                  {AllColumns ? <td>{val.Type}</td> : null}

                  <td>
                    <input
                      type="number"
                      className="form-control form-rounded"
                      value={val.QTY ?? ''}
                      placeholder={onHandDisplay !== '' ? String(onHandDisplay) : ''}
                      onChange={(e) => handleInputChange(e, realIndex, 'QTY')}
                      disabled={!Qtyvalue}
                    />
                  </td>

                  <td>{onHandDisplay}</td>
                </tr>
              );
            })}

            {!filteredParts.length && (
              <tr>
                <td colSpan={AllColumns ? 8 : 6} className="text-center text-muted">
                  No records to display
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {printTrigger && (
        <Print
          tableHTML={printTrigger.html}
          user="Vikas"
          title={Area}
          onComplete={() => setPrintTrigger(false)}
        />
      )}
    </div>
  );
}

export default Flex_Inventory;